<template>
    <div>
        <div v-if="editMode">
        </div>
        <div v-else>
            {{ connection.connection_slug }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        connection: Object
    },
    data() {
        return {
            editMode: false
        }
    }
}
</script>